import React from 'react';

/**
 * Barre positionnant la note de l'élève entre le min et le max de la classe.
 */
const NotePositionChart = ({ note, noteMin, noteMax }) => {
  if (note == null || noteMin == null || noteMax == null) return null;

  const range = noteMax - noteMin;
  const pct = range > 0 ? ((note - noteMin) / range) * 100 : 50;

  return (
    <div className="mt-2">
      <div className="flex justify-between text-[10px] text-slate-400 mb-1">
        <span>Min {noteMin}</span>
        <span className="font-semibold text-primary-600">{note}</span>
        <span>Max {noteMax}</span>
      </div>
      <div className="relative h-2 bg-slate-100 rounded-full overflow-hidden">
        <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-red-200 via-yellow-200 to-green-200 w-full rounded-full opacity-60" />
        <div
          className="absolute top-1/2 -translate-y-1/2 w-3 h-3 bg-primary-600 border-2 border-white rounded-full shadow"
          style={{ left: `calc(${Math.min(100, Math.max(0, pct))}% - 6px)` }}
          title={`Note : ${note} / ${noteMin}–${noteMax}`}
        />
      </div>
    </div>
  );
};

export default NotePositionChart;
